import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PreorderStore {
  tab: string;
  storeCode: string | null;
  storeCategoryCode: string | null;
  storeTypeCode: string | null;
}

export interface PreorderState {
  store: PreorderStore;
}

const initialState: PreorderState = {
  store: {
    tab: '1',
    storeCode: null,
    storeCategoryCode: null,
    storeTypeCode: null
  }
};

export const preorderSlice = createSlice({
  name: 'preorder',
  initialState,
  reducers: {
    setPreorderStore: (state, { payload }: PayloadAction<Partial<PreorderStore>>) => {
      state.store = {
        ...state?.store,
        ...payload
      };
    }
  }
});

export const { setPreorderStore } = preorderSlice.actions;

export default preorderSlice.reducer;
